import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=0971cf61&scoped=true&"
import script from "./shop.vue?vue&type=script&lang=js&"
export * from "./shop.vue?vue&type=script&lang=js&"
import style0 from "./shop.vue?vue&type=style&index=0&id=0971cf61&prod&scoped=true&lang=css&"
import style1 from "./shop.vue?vue&type=style&index=1&id=0971cf61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971cf61",
  null
  
)

export default component.exports